import type { CategoryGroupWithCategoriesResponse, SpendControlCategoryResponse } from '@mynt/backoffice-api-spec/spendcontrols'
import type { SpendControlRow } from 'SpendControl/SpendControlTable'

export const mapGroupRow = (group: CategoryGroupWithCategoriesResponse, uniqueCats: SpendControlCategoryResponse[]): SpendControlRow => ({
  id: group.id,
  name: group.name,
  description: group.description,
  path: [group.id],
  modifiedAt: group.modifiedAt ?? '',
  order: group.order ?? undefined,
  categoryIds: uniqueCats.map((cat) => cat.id),
})

export const mapCategoryRow = (cat: SpendControlCategoryResponse, groupId: string): SpendControlRow => ({
  id: cat.id,
  name: cat.name,
  description: cat.description,
  path: [groupId, cat.id],
  modifiedAt: cat.modifiedAt,
  order: cat.order ?? undefined,
})

export const VIRTUAL_UNGROUPED_ROW: SpendControlRow = {
  id: '__ungrouped__',
  name: '-',
  description: undefined,
  path: ['__ungrouped__'],
  modifiedAt: '',
  order: undefined,
  categoryIds: [],
  virtual: true,
}
